import React from "react";
import PropTypes from "prop-types";
import CustomModal from "components/Modal";
// import InputField from "components/Input";
import Button from "components/Button";
import "./index.scss";

const DeleteProfileModal = ({
  // buttonAction,
  // setDeleteAccount,
  // deleteValue,
  isOpen,
  onClose,
  onRequestClose,
}) => {
  return (
    <CustomModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      onClose={onClose}
      size="medium"
    >
      <div
        className="delete-account"
        data-testid="delete-account-modal-content"
      >
        {/* <h3 className="title">Oops!</h3>
        <p className="paragraph">
          Are you sure ?{" "}
          <p className="warning">
            Deleting an account will remove all of your account details
            including data.
          </p>
        </p>
        <p className="paragraph">
          Type
          <span className="bold"> CONFIRM </span>
          to delete account
        </p>
        <InputField
          value={deleteValue}
          onChange={(event) => setDeleteAccount(event.target.value)}
        />
        <Button
          id="delete-button"
          type="solid"
          color="red"
          label="Delete Account"
          block
          icon="chevron-right"
          onClick={buttonAction}
          disabled={deleteValue !== "CONFIRM"}
        /> */}
        <h3 className="title">Delete Account</h3>
        <div className="paragraph">
          <p className="warning">
            Please contact as at{" "}
            <a className="email" href="mailto:support@datafarming.com.au">
              support@datafarming.com.au
            </a>{" "}
            to delete your account.
          </p>
        </div>
        <Button
          type="outlined"
          color="white"
          id="ok-button"
          label="Got it"
          block
          onClick={onClose}
        />
      </div>
    </CustomModal>
  );
};

DeleteProfileModal.propTypes = {
  // buttonAction: PropTypes.func.isRequired,
  // deleteValue: PropTypes.string.isRequired,
  // setDeleteAccount: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
};

export default DeleteProfileModal;
